import CustomFieldsController from "core-app/../stimulus/controllers/dynamic/admin/custom-fields.controller";

export function apply() {
  let controllerPrototype = CustomFieldsController.prototype as any;
  let originalToggleFormat = controllerPrototype.toggleFormat;
  controllerPrototype.toggleFormat = function (format:string) {
    originalToggleFormat.call(this, format);
    switch (format) {
      case 'datetime':
        this.activate(this.defaultValueTargets, false);
        this.activate(this.possibleValuesTargets, false);
        this.hide(...this.lengthTargets, ...this.regexpTargets, ...this.defaultValueTargets);
        this.unsearchable();
        break;
      case 'link':
        this.show(...this.lengthTargets, ...this.searchableTargets);
        this.hide(...this.regexpTargets);
        this.activate(this.possibleValuesTargets, false);
        break;
      case 'work_package':
      case 'attachment':
        this.activate(this.possibleValuesTargets, false);
        this.show(...this.multiSelectTargets);
        this.activate(this.multiSelectTargets);
        this.hide(...this.lengthTargets, ...this.regexpTargets, ...this.defaultValueTargets);
        this.unsearchable();
        break;
    }
  }
}
